import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { LocalFaturamentoSelectModule } from '../../../../local-faturamento/select';

import { PedidoIntegracaoErpImportModalComponent } from './modal';

@NgModule({
    imports: [
        SharedModule,
        LocalFaturamentoSelectModule
    ],
    declarations: [
        PedidoIntegracaoErpImportModalComponent
    ],
    exports: [
        PedidoIntegracaoErpImportModalComponent
    ]
})
export class PedidoIntegracaoErpImportModule { }
